import { Divider } from '@mui/material';
import domtoimage from 'dom-to-image';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactNativeModal from 'react-native-modal';
import { IconSvg } from 'src/assets';
import { ReservationProps } from 'src/common/api/response';
import { Container, CustomQRCode, DateTimeCalendar, RegularText, Row, SizedBox } from 'src/components';
import { TimeLine } from 'src/components/layout/Timeline';
import { AppColors } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';
// import { useScreenShot } from './useScreenShot';

export const TicketForShare = ({
  service,
  isVisible,
  reservation,
  onClose,
}: {
  service: string;
  isVisible: boolean;
  reservation: ReservationProps;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const qrCodeTicketRef = React.useRef<any>();

  // const [image, takeScreenShot, { error }] = useScreenShot({ type: 'image/png', quality: 1 });

  useEffect(() => {
    if (!isVisible) return;
    // setTimeout(() => {
    //   takeScreenShot(qrCodeTicketRef.current);
    // }, 200);
    setTimeout(() => {
      handleCapture();
    }, 500);
    // setTimeout(() => {
    //   onClose();
    // }, 2000);
  }, [isVisible]);

  const handleCapture = async () => {
    if (!qrCodeTicketRef.current) return;
    try {
      const scale = 2;
      const response = await domtoimage.toPng(qrCodeTicketRef.current, {
        quality: 1,
        width: qrCodeTicketRef.current.clientWidth * scale,
        height: qrCodeTicketRef.current.clientHeight * scale,
        style: {
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        },
      });
      const imageWithoutPrefix = response.replace('data:image/png;base64,', '');
      if (window?.nham24?.request) {
        window.nham24.request('consolelog', { title: 'sharing now', imageWithoutPrefix });
        onClose();
        await window.nham24.request('app/share', {
          isBase64: true,
          type: 'image/png',
          filename: 'ticket.png',
          url: imageWithoutPrefix,
        });
      } else {
        onClose();
      }
      // const localUri = await captureRef(qrCodeTicketRef, {
      //   height: 440,
      //   quality: 1,
      //   result: 'base64',
      //   format: 'png',
      // });
      console.log({ response });
    } catch (error) {
      onClose();
      if (window?.nham24?.request) {
        window.nham24.request('consolelog', { error });
      }
      console.log({ error });
    }
  };

  // useEffect(() => {
  //   if (!image || !isVisible) return;
  //   console.log('image', image);
  //   const imageWithoutPrefix = image.replace('data:image/png;base64,', '');
  //   // console.log('sharing now', imageWithoutPrefix);
  //   if (window?.nham24?.request) {
  //     window.nham24.request('consolelog', { title: 'sharing now', imageWithoutPrefix });
  //     window.nham24.request('app/share', {
  //       isBase64: true,
  //       type: 'image/png',
  //       filename: 'ticket.png',
  //       url: imageWithoutPrefix,
  //     });
  //   }
  // }, [image, isVisible]);

  return (
    <ReactNativeModal isVisible={isVisible}>
      <Container
        style={{ overflow: 'hidden' }}
        borderRadius={metrics.borderRadius}
        ref={qrCodeTicketRef}
        backgroundColor={AppColors.white}>
        <Container
          align="center"
          backgroundColor={AppColors.primary}
          padding={metrics.huge}
          paddingBottom={metrics.large}>
          <CustomQRCode isAnimate={false} data={reservation.reservationId} />
          <SizedBox height="medium" />
          <RegularText fontWeight="bold" color={AppColors.white}>
            ID: {reservation.reservationId}
          </RegularText>
        </Container>
        <Container padding={metrics.large}>
          <Row width="100%">
            <Container flex>
              {/* <SmallOperator operator={reservation.operator} /> */}
              <RegularText fontSize="large" fontWeight="bold">
                {reservation.operator?.name}
              </RegularText>
            </Container>
            <RegularText color={AppColors.gray}>{service}</RegularText>
          </Row>
          <Divider style={{ marginTop: metrics.medium, marginBottom: metrics.medium }} />
          <TimeLine showMinimal transits={reservation.transits} />
          {/* <Divider style={{ marginTop: metrics.small, marginBottom: metrics.large }} /> */}
          <Row style={{ justifyContent: 'space-between' }}>
            <DateTimeCalendar
              // fontWeight="bold"
              // lineColor={AppColors.white50}

              date={reservation.departureDate || ''}
              time={reservation.departureTime}
            />
            <Row style={{ justifyContent: 'center', alignItems: 'center' }}>
              <IconSvg.Seats fill={AppColors.lighterGray} />
              <RegularText fontSize="medium"> x {reservation.seatCount}</RegularText>
            </Row>
          </Row>
          <Divider style={{ marginTop: metrics.medium, marginBottom: metrics.medium }} />
          <Row marginBottom={metrics.medium} width="100%">
            <RegularText
              style={
                {
                  lineHeight: '150%',
                } as any
              }
              color={AppColors.gray}>
              {t('seats')}
            </RegularText>
            <Container flex paddingLeft={metrics.small}>
              <RegularText
                style={
                  {
                    lineHeight: '150%',
                  } as any
                }>
                {reservation.seats.map(seat => seat.name).join('  -  ')}
              </RegularText>
            </Container>
          </Row>

          <Container marginTop={metrics.large} align="center">
            <IconSvg.GO24 />
          </Container>
        </Container>
      </Container>
    </ReactNativeModal>
  );
};
